<template>
  <main>
    <SectionHero :variant="hero.variant">
      <OrganismHero :hero="hero" />
    </SectionHero>
    <SectionDefault>
      <Builder :blocks="blocks" />
    </SectionDefault>
  </main>
</template>

<script>
import Builder from '../components/builder/Builder'
import pageBuilder from '../components/mixins/pageBuilder.js'
import OrganismHero from '../components/organisms/layouts/OrganismHero'
import SectionDefault from '../components/templates/layouts/SectionDefault'
import SectionHero from '../components/templates/layouts/SectionHero'

const mixinPageBuilder = pageBuilder({
  pageUrl: 'franchise',
})

export default {
  name: 'Franchise',
  components: {
    Builder,
    SectionDefault,
    SectionHero,
    OrganismHero,
  },
  mixins: [mixinPageBuilder],
  meta: {
    theme: 'dark',
  },
  data: c => {
    return {
      hero: {
        variant: 'dark-parallax',
        title1: 'ОТКРЫТЬ',
        title2: 'ФИТНЕС-КЛУБ',
        image: 'franchise/hero.webp',
        imageWrap: 'img-border-0',
        imageMobile: 'franchise/hero-mobile.jpg',
        breadcrumbs: c.$breadcrumbs.franchise(),
      },
      links: [
        {
          to: '#about',
          name: 'О франшизе',
          class: 'active',
        },
        {
          to: '#numbers',
          name: 'Цифры',
        },
        {
          to: '#peculiarities',
          name: 'Особенности',
        },
        {
          to: '#services',
          name: 'Услуги',
        },
        {
          to: '#contacts',
          name: 'Контакты',
        },
      ],
    }
  },
}
</script>
